module.exports = __webpack_public_path__ + "static/media/out-for-delivery.e1e334c9.svg";